<div class="header" [attr.data-type]="lesson()?.type">
    <h2>{{ 'lessons.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'lessons.error.unavailable' | translate" />
} @else if (lesson(); as lesson) {
    <div class="body">
        <div class="entity-header">
            <div class="identity">
                <h1>{{ lesson.name }}</h1>
                <app-type-chip [type]="lesson.type" translationPrefix="lessons.type" />
            </div>
        </div>

        <div class="section">
            <h2>{{ 'lessons.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'lessons.form.name' | translate }}</span>
                <span class="value">{{ lesson.name || '-' }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'lessons.form.duration' | translate }}</span>
                <span class="value">{{ lesson.duration | duration }}</span>
            </div>
        </div>

        @switch (lesson.type) {
            @case ('video') {
                <div class="section">
                    <h2>{{ 'lessons.fieldset.media' | translate }}</h2>
                    <div class="media-row">
                        <div class="field">
                            <span class="label">{{ 'lessons.form.media' | translate }}</span>
                            @if (lesson.mediaId) {
                                <app-media-video [mediaId]="lesson.mediaId" />
                            } @else {
                                <span class="value">-</span>
                            }
                        </div>
                        <div class="field">
                            <span class="label">{{ 'lessons.form.placeholder' | translate }}</span>
                            @if (lesson.mediaPlaceholderId) {
                                <app-media-image [mediaId]="lesson.mediaPlaceholderId" />
                            } @else {
                                <span class="value">-</span>
                            }
                        </div>
                    </div>
                </div>

                <div class="section">
                    <h2>{{ 'lessons.fieldset.transcription' | translate }}</h2>
                    <div class="field">
                        <span class="label">{{ 'lessons.form.transcription' | translate }}</span>
                        @if (lesson.transcription) {
                            <app-media-text [content]="lesson.transcription" />
                        } @else {
                            <span class="value">-</span>
                        }
                    </div>
                </div>
            }
            @case ('audio') {
                <div class="section">
                    <h2>{{ 'lessons.fieldset.media' | translate }}</h2>
                    <div class="field">
                        <span class="label">{{ 'lessons.form.media' | translate }}</span>
                        @if (lesson.mediaId) {
                            <app-media-audio [mediaId]="lesson.mediaId" />
                        } @else {
                            <span class="value">-</span>
                        }
                    </div>
                </div>

                <div class="section">
                    <h2>{{ 'lessons.fieldset.transcription' | translate }}</h2>
                    <div class="field">
                        <span class="label">{{ 'lessons.form.transcription' | translate }}</span>
                        @if (lesson.transcription) {
                            <app-media-text [content]="lesson.transcription" />
                        } @else {
                            <span class="value">-</span>
                        }
                    </div>
                </div>
            }
            @case ('text') {
                <div class="section">
                    <h2>{{ 'lessons.fieldset.content' | translate }}</h2>
                    @if (lesson.mediaId) {
                        <app-media-text [mediaId]="lesson.mediaId" />
                    } @else {
                        <span class="value">-</span>
                    }
                </div>
            }
        }

        <div class="section">
            <h2>{{ 'lessons.fieldset.materials' | translate }}</h2>
            <app-material-list-view [ids]="lesson.materialIds" emptyKey="lessons.materials.empty" />
        </div>
    </div>

    <div class="footer">
        <app-delete-button [lessonId]="lesson.id" [saving]="saving()" />
        <p-button [label]="'lessons.detail.edit' | translate" icon="pi pi-pencil" (onClick)="onEdit()" />
    </div>
}
